import {
  Stack,
  HStack,
  FormControl,
  FormLabel,
  Input,
  Heading,
  Select,
  Radio,
  RadioGroup,
  IconButton,
  Button,
  useToast,
  useMediaQuery,
  FormErrorMessage,
  useDisclosure,
} from "@chakra-ui/react";
import { Formik, Form, Field } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { MdNavigateNext, MdArrowBack } from "react-icons/md";
import {
  putUsuarios,
  createUsuario,
  getUsuarios,
  reactivarUsuario,
} from "../helpers/api.helper";
import { getClientes } from "../../inventario/helpers/api.helper";
import { validateField } from "../../../utils/Validaciones";
import ModalReactivarUsuario from "./ModalReactivarUsuario";

const FormCrearEditarUsuarios = (props) => {
  const { type, initUsuarios, user } = props;
  const [loading, setLoading] = useState(false);
  const [usuario, setUsuario] = useState([]);
  const [clientes, setClientes] = useState([]);
  const navigate = useNavigate();
  const id = useParams();
  const toast = useToast();
  const [mobile] = useMediaQuery("(max-width: 425px)");
  let codigoUsuario = Math.floor(Math.random() * 101);

  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose,
  } = useDisclosure();
  const [usuarioEliminado, setUsuarioEliminado] = useState(null);
  const pendingDataRef = useRef(null);

  const handleReactivar = async () => {
    setLoading(true);
    const res = await reactivarUsuario({
      ...pendingDataRef.current,
      idUsuario: usuarioEliminado.idUsuario,
    });
    setLoading(false);
    onModalClose();
    if (res && res.status === 200) {
      toast({
        status: "success",
        isClosable: true,
        title: "Usuario reactivado correctamente",
        duration: 3000,
      });
      navigate(-1);
      initUsuarios?.();
    } else {
      toast({
        status: "error",
        isClosable: true,
        title: "Error al reactivar usuario",
        description: res?.data?.message || "Error al reactivar usuario",
        duration: 3000,
      });
    }
  };

  const initData = async () => {
    setLoading(true);
    let res;

    res = await getUsuarios(id);

    if (res.status === 200) {
      setUsuario(res.data[0]);
    } else {
      toast({
        title: "Error",
        description: "Error al cargar los datos",
        isClosable: true,
        duration: 3000,
      });
    }

    res = await getClientes();

    if (res.status === 200) {
      setClientes(res.data);
    } else {
      toast({
        title: "Error",
        description: "Error al cargar los datos",
        isClosable: true,
        duration: 3000,
      });
    }

    setLoading(false);
  };

  let initialValues =
    type === "editar"
      ? {
          nombre: usuario.nombre,
          apellido: usuario.apellido,
          email: usuario.email,
          idRol: usuario.idRol,
          estado: usuario.estado,
          codigoUsuario: usuario.codigoUsuario,
          idTelegram: usuario.idTelegram,
          puesto: usuario.puesto,
          idCliente: usuario.idCliente,
        }
      : {
          nombre: "",
          apellido: "",
          email: "",
          idRol: "",
          estado: "",
          idTelegram: "",
          puesto: "",
          idCliente: "",
        };

  useEffect(() => {
    initData();
  }, []);

  return (
    <Stack bg="brand.fondo" w="100%" h="md" borderRadius={10} spacing={7}>
      <ModalReactivarUsuario
        isOpen={isModalOpen}
        onClose={onModalClose}
        onConfirm={handleReactivar}
        usuario={usuarioEliminado}
        isLoading={loading}
      />
      <ModalReactivarUsuario
        isOpen={isModalOpen}
        onClose={onModalClose}
        onConfirm={handleReactivar}
        usuario={usuarioEliminado}
        isLoading={loading}
      />
      <HStack w="100%" pl={5}>
        <IconButton
          icon={<MdArrowBack />}
          variant="link"
          onClick={() => navigate(-1)}
          fontSize="24px"
        />
        {type === "editar" && (
          <Heading fontWeight="medium" py={3}>
            Editar Usuario
          </Heading>
        )}
        {type === "crear" && (
          <Heading fontWeight="medium" py={3}>
            Nuevo Usuario
          </Heading>
        )}
      </HStack>
      {!loading && (
        <Formik
          initialValues={initialValues}
          onSubmit={async (values) => {
            setLoading(true);
            if (!values.nombre) {
              setLoading(false);
              return toast({
                title: "Error",
                description: "Nombre de usuario requerido",
                status: "error",
                isClosable: true,
                duration: 3000,
              });
            }
            if (!values.email) {
              setLoading(false);
              return toast({
                title: "Error",
                description: "Email requerido",
                status: "error",
                isClosable: true,
                duration: 3000,
              });
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              setLoading(false);
              return toast({
                title: "Error",
                description: "Email invalido",
                status: "error",
                isClosable: true,
                duration: 3000,
              });
            }
            if (!values.idRol) {
              setLoading(false);
              return toast({
                title: "Error",
                description: "Rol de usuario requerido",
                status: "error",
                isClosable: true,
                duration: 3000,
              });
            }
            if (!values.estado) {
              setLoading(false);
              return toast({
                title: "Error",
                description: "Estado de usuario requerido",
                status: "error",
                isClosable: true,
                duration: 3000,
              });
            }

            let data;

            if (
              values.idRol === "userOperaciones" ||
              values.idRol === "usuarioBrent"
            ) {
              data = {
                nombre: values.nombre,
                apellido: null,
                email: values.email,
                estado: values.estado,
                idRol: values.idRol,
                idTelegram: values.idTelegram || null,
                codigoUsuario: codigoUsuario,
                puesto: values.puesto,
              };
            } else if (values.idRol === "cliente") {
              data = {
                nombre: values.nombre,
                apellido: null,
                email: values.email,
                estado: values.estado,
                idRol: values.idRol,
                idTelegram: values.idTelegram || null,
                codigoUsuario: codigoUsuario,
                idCliente: values.idCliente,
              };
            } else {
              data = {
                nombre: values.nombre,
                apellido: null,
                email: values.email,
                estado: values.estado,
                idRol: values.idRol,
                idTelegram: values.idTelegram || null,
                codigoUsuario: codigoUsuario,
                puesto: values.puesto,
              };
            }

            let res;

            if (type === "editar") {
              res = await putUsuarios({
                ...data,
                idUsuario: usuario.idUsuario,
              });
            }
            if (type === "crear") {
              res = await createUsuario(data);
            }

            if (res.status === 200) {
              toast({
                status: "success",
                isClosable: true,
                title: `Usuario ${
                  type === "crear" ? "creado" : "editado"
                } correctamente`,
                duration: 3000,
              });
              navigate(-1);
              initUsuarios?.();
            } else if (
              type === "crear" &&
              res.status === 409 &&
              res.data?.tipo === "eliminado"
            ) {
              setLoading(false);
              setUsuarioEliminado(res.data.usuario);
              pendingDataRef.current = data;
              onModalOpen();
              return;
            } else if (
              type === "crear" &&
              res.status === 409 &&
              res.data?.tipo === "activo"
            ) {
              setLoading(false);
              return toast({
                status: "error",
                isClosable: true,
                title: "Usuario duplicado",
                description:
                  res.data.message ||
                  "Ya existe un usuario activo con esos datos.",
                duration: 4000,
              });
            } else {
              return toast({
                status: "error",
                isClosable: true,
                title: `Error al ${
                  type === "crear" ? "crear" : "editar"
                } usuario`,
                description: res?.data?.message || "Error inesperado",
                duration: 4000,
              });
            }

            setLoading(false);
          }}
        >
          {({
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            errors,
            touched,
          }) => (
            <Form id="formUsuarios">
              <Stack w="100%" spacing={10} px={7}>
                <Stack
                  w="100%"
                  direction={mobile ? "column" : "row"}
                  spacing={10}
                >
                  <Stack placeSelf={"start"}>
                    <Field
                      name="nombre"
                      validate={(value) =>
                        validateField("letras", value, "Nombre de usuario")
                      }
                    >
                      {({ field }) => (
                        <FormControl
                          isInvalid={errors.nombre && touched.nombre}
                          w={"xs"}
                          isRequired
                        >
                          <FormLabel fontWeight="bold">
                            Nombre y Apellido
                          </FormLabel>
                          <Input
                            {...field}
                            name="nombre"
                            type="text"
                            placeholder="Nombre y Apellido"
                            onChange={handleChange}
                            value={values.nombre}
                            w="xs"
                          />
                          <FormErrorMessage>{errors.nombre}</FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </Stack>
                  <Stack placeSelf={"start"}>
                    <Field
                      name="email"
                      validate={(value) =>
                        validateField("email", value, "Email")
                      }
                    >
                      {({ field }) => (
                        <FormControl
                          isInvalid={errors.email && touched.email}
                          w={"xs"}
                          isRequired
                        >
                          <FormLabel fontWeight="bold">Email</FormLabel>
                          <Input
                            {...field}
                            name="email"
                            type="email"
                            placeholder="Email"
                            onChange={handleChange}
                            w="xs"
                            value={values.email}
                          />
                          <FormErrorMessage>{errors.email}</FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </Stack>
                  <Stack placeSelf={"start"}>
                    <Field
                      name="idTelegram"
                      validate={(value) =>
                        validateField("numberWnull", value, "ID Telegram")
                      }
                    >
                      {({ field }) => (
                        <FormControl
                          isInvalid={errors.idTelegram && touched.idTelegram}
                          w={"xs"}
                        >
                          <FormLabel fontWeight="bold">ID Telegram</FormLabel>
                          <Input
                            {...field}
                            name="idTelegram"
                            type="text"
                            placeholder="ID Telegram"
                            onChange={handleChange}
                            value={values.idTelegram}
                            w="xs"
                          />
                          <FormErrorMessage>
                            {errors.idTelegram}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </Stack>
                </Stack>
                <Stack direction={mobile ? "column" : "row"} spacing={10}>
                  <FormControl w={"xs"} isRequired>
                    <FormLabel fontWeight="bold">Rol</FormLabel>
                    <Select
                      name="idRol"
                      placeholder="Seleccione rol"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.idRol}
                    >
                      {user.idRol === "admin" && (
                        <option value="admin">Admin</option>
                      )}
                      <option value="cliente">Cliente</option>
                      <option value="usuarioBrent">Usuario BRENT</option>
                      <option value="coorOp">Coordinador de Operaciones</option>
                      <option value="userOperaciones">Operaciones</option>
                      <option value="userFacturacion">Facturación</option>
                      <option value="userHS">Higiene y Seguridad</option>
                      <option value="gerencia">Gerencia</option>
                      <option value="usuarioIT">Usuario IT</option>
                      <option value="userMantenimiento">Mantenimiento</option>
                    </Select>
                  </FormControl>
                  {(values.idRol === "userOperaciones" ||
                    values.idRol === "usuarioBrent") && (
                    <FormControl w={"xs"}>
                      <FormLabel fontWeight="bold">Puesto</FormLabel>
                      <Select
                        name="puesto"
                        placeholder="Seleccione puesto"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.puesto}
                      >
                        {values.idRol === "userOperaciones" && (
                          <>
                            <option value="supervisor">Supervisor</option>
                            <option value="operador">Operador</option>
                          </>
                        )}
                        {values.idRol === "usuarioBrent" && (
                          <>
                            <option value="maquinista">Maquinista</option>
                            <option value="brent">Usuario Brent</option>
                          </>
                        )}
                      </Select>
                    </FormControl>
                  )}
                  {values.idRol === "cliente" && (
                    <FormControl w={"xs"}>
                      <FormLabel fontWeight="bold">Cliente</FormLabel>
                      <Select
                        name="idCliente"
                        placeholder="Seleccione cliente"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.idCliente}
                      >
                        {clientes.map((e) => (
                          <option key={e.idCliente} value={e.idCliente}>
                            {e.nombreCliente}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                  <FormControl w={"xs"} alignSelf="center">
                    <RadioGroup
                      name="estado"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.estado}
                    >
                      <Stack direction="row">
                        <Radio
                          value="activado"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          Activar
                        </Radio>
                        <Radio
                          value="desactivado"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          Desactivar
                        </Radio>
                      </Stack>
                    </RadioGroup>
                  </FormControl>
                </Stack>

                <Button
                  placeSelf="end"
                  rightIcon={<MdNavigateNext size={16} />}
                  bg="brand.naranja"
                  form="formUsuarios"
                  fontSize={12}
                  color="white"
                  letterSpacing={2}
                  isLoading={loading}
                  isDisabled={user.idRol === "usuarioIT"}
                  size="md"
                  onClick={handleSubmit}
                >
                  Finalizar
                </Button>
              </Stack>
            </Form>
          )}
        </Formik>
      )}
    </Stack>
  );
};

export default FormCrearEditarUsuarios;
